import styled from 'styled-components';
import {
  Box,
  ButtonPrimary,
  spacer12,
  spacer16,
  spacer24,
  spacer8,
} from '@spotify-internal/encore-web';

export const StyledTrackRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${spacer24};
  justify-content: space-between;
`;

export const StyledTrackRowInner = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledTrackRowInfo = styled.div`
  display: flex;
  gap: ${spacer8};
`;

export const StyledTrackNumber = styled.div`
  margin-right: ${spacer16};
  margin-left: -${spacer8};
`;

export const StyledImageContainer = styled.div`
  margin-right: ${spacer12};
  display: flex;
`;

export const StyledTrackNameDetails = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 88px;
`;

export const StyledTrackButton = styled(ButtonPrimary)`
  cursor: pointer;
  margin-bottom: ${spacer8};
  margin-left: ${spacer8};
`;

export const InactiveStyledTrackButton = styled(StyledTrackButton)`
  cursor: auto;
`;

export const StyledButtonContainer = styled.div`
  margin-bottom: ${spacer8};
`;

export const PillsContainer = styled.div`
  margin-bottom: ${spacer16};
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
`;

export const StyledBox = styled(Box)`
  z-index: auto;
  cursor: initial;
`;

export const StyledNameAndExplicitTagContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 11px;
`;
